import type { Root } from './prototypeTypes';

export interface CommunityProofStats {
	ideasProduced: string | null;
	avgReviewTime: string | null;
}

/** Hide unavailable community proof instead of presenting an invented dash. */
export function syncCommunityProofBadge(root: Root, stats: CommunityProofStats): void {
	root.querySelectorAll<HTMLElement>('[data-community-proof-badge]').forEach((badge) => {
		const visibleCount = Object.entries(stats).filter(([key, value]) => {
			const item = badge.querySelector<HTMLElement>(`[data-community-stat="${key}"]`);
			const visible = value !== null;
			if (item) item.hidden = !visible;
			return visible;
		}).length;
		badge.hidden = visibleCount === 0;
	});
}
